// https://stackoverflow.com/questions/32720294/check-icd10-via-regex

const regex = /^[A-Z]\d[A-Z\d](\.[A-Z\d]{0,4})?$/;

export function icdCodeValidator(code: string) {
  return regex.test(code);
}
